import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"
import { z } from "zod"

import { ProductWarehouseListSortField, SortingOrder } from "@/graphql/codegen/graphql"
import { ProductCostBreakdownsContainer } from "@/screens/Products/components/Product/Costs"

const productCostBreakdownSearchSchema = z.object({
  field: z.nativeEnum(ProductWarehouseListSortField).optional().default(ProductWarehouseListSortField.LastReceiptDate),
  order: z.nativeEnum(SortingOrder).optional().default(SortingOrder.Desc),
})

export const PRODUCT_COSTS_LAID_DOWN_ROUTE_PATH = "/app/product/$productId/edit/_layout/costs/_layout/laid-down"

export const Route = createFileRoute(PRODUCT_COSTS_LAID_DOWN_ROUTE_PATH)({
  validateSearch: zodValidator(productCostBreakdownSearchSchema),
  search: {
    middlewares: [retainSearchParams(["field", "order"])],
  },
  component: ProductCostBreakdownsContainer,
})
